import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { REPORT_BASE_PATH } from '../../../../../../../../../features/report/report-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/reporting/archive/_report')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'report-list',
        label: 'Reports',
        to: REPORT_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
